import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  total: 0,
  loading: false,
};

export const getBannerList = createAsyncThunk(
  "get-banner",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("banner/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createBanner = createAsyncThunk(
  "create-banner",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("banner", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateBanner = createAsyncThunk(
  "update-banner",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/banner/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteBanner = createAsyncThunk(
  "delete-banner",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/banner/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const reorderBanner = createAsyncThunk(
  "reorder-banner",
  async (banners, { dispatch }) => {
    try {
      const response = await axios.put("/banner/reorder", { banners });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBannerList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBannerList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.bannerList ?? [];
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getBannerList.rejected, (state) => {
        state.loading = false;
        state.list = [];
        state.total = 0;
      });
  },
});

export default bannerSlice.reducer;
